import React, { forwardRef } from 'react';
import MaterialTable from 'material-table';

import { makeStyles } from '@material-ui/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { Info } from '.'

const useStyles = makeStyles((theme) => ({
  sortUp: {
    position: 'absolute',
    top: '-16px',
    left: '-2px'
  },
  sortDown: {
    position: 'absolute',
    top: '-8px',
    left: '-2px',
    color: theme.palette.neutral.med
  },
}));

export const Table = ({columns, data, ...props}) => {

  const classes = useStyles();

  const renderSortArrow = forwardRef( ({className, ...props}, ref) => {
    return  <span className={className} style={{position: 'relative'}}><ArrowDropUpIcon color='inherit' className={classes.sortUp + ' sortUpArrow'}/><ArrowDropDownIcon color='inherit' className={classes.sortDown + ' sortDownArrow'}/></span>
  })


  return (
    <div className={classes.root}>
      <MaterialTable
        title=""
        columns={columns}
        data={data}
        style={{
          background: 'transparent',
          boxShadow: 'none',          
        }} 
        icons={{ SortArrow: renderSortArrow }}
        labelRowsPerPage="Rows to show:"
        options={{
          draggable: false,
          emptyRowsWhenPaging: false,
          headerStyle: {
            backgroundColor: 'transparent',
            fontWeight: '600',
            borderBottom: 'none',
            paddingTop: '0px',
            paddingBottom: '0px'
          },
          paginationType: 'stepped',
          searchFieldVariant: 'outlined',
          searchFieldStyle: {
            background: '#fff',
            fontSize: '18px',
          },
          sorting: true,
          thirdSortClick: false,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: <Info heading="No items found" details="Make sure all words are spelled correctly or try another search term." /> 
          } 
        }}
      />
    </div>
  );
}